import React from "react";

export const NoData = () => (
	<div className="container has-text-centered is-bordered mt-6 fa-2x">
		<h1>No Data</h1>
	</div>
);
